"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ShieldCheck, Leaf, Clock, Phone } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TopDollarHero() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const features = [{
    icon: ShieldCheck,
    text: "Licensed & Certified"
  }, {
    icon: Leaf,
    text: "Bulk Material Experts"
  }, {
    icon: Clock,
    text: "On-Time Delivery"
  }];
  return <section data-section-id="180155" id="precision-hauling-for-the-southern-corridor" className="dark bg-background text-foreground relative min-h-[90vh] flex items-center overflow-hidden pt-24 pb-16 lg:pt-32 lg:pb-24">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden">
        <div className="absolute top-1/2 right-0 -translate-y-1/2 w-full md:w-[60%] h-[150%] bg-[radial-gradient(ellipse_at_right_center,var(--color-primary)_0%,transparent_60%)] opacity-[0.07] mix-blend-screen blur-3xl"></div>
        {}
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)]"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full max-w-7xl">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-8">
          
          {}
          <div ref={textRef} className={`lg:w-[60%] flex flex-col items-start transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}
            <div className="flex items-center gap-3 mb-6">
              <span className="size-2.5 rounded-full bg-primary shadow-[0_0_12px_var(--color-primary)] animate-pulse"></span>
              <span className="font-default text-sm md:text-base font-bold uppercase tracking-[0.2em] text-muted-foreground">
                DFW & SOUTHEAST LOGISTICS
              </span>
            </div>

            {}
            <h1 className="font-default text-5xl sm:text-6xl lg:text-[5.5rem] leading-[1.05] font-bold uppercase tracking-tighter text-foreground">
              Local Precision. <br className="hidden sm:block" />
              <span className="text-primary relative inline-block mt-2 sm:mt-0 drop-shadow-[0_0_25px_rgba(251,191,36,0.4)]">
                Regional Power.
              </span>
            </h1>

            {}
            <p className="font-default text-lg sm:text-xl text-muted-foreground mt-8 max-w-2xl leading-relaxed">Specialized last-mile delivery for the Dallas/Ft Worth market and heavy-haul regional logistics across the Southeast. Built for stone, lumber, bulk material providers and more.</p>

            {}
            <div className="mt-10 flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
              <Button asChild size="lg" className="font-default font-bold text-lg h-14 px-8 rounded-sm bg-primary text-primary-foreground shadow-md shadow-primary/20 hover:shadow-primary/40 transition-all duration-300">
                <Link to="tel:+1-469-590-4364">
                  <Phone className="mr-2 size-5" />
                  CALL +1-469-590-4364
                </Link>
              </Button>
            </div>

            {}
            <div className="mt-14 flex flex-wrap gap-x-8 gap-y-4">
              {features.map((feature, i) => <div key={i} data-index={i} className="flex items-center gap-3 group">
                  <div className="flex items-center justify-center size-10 rounded-sm bg-primary/10 text-primary border-2 border-primary/20 group-hover:bg-primary/20 group-hover:scale-110 transition-all duration-300">
                    <feature.icon className="size-5" />
                  </div>
                  <span className="font-default text-sm md:text-base font-semibold text-foreground/90 tracking-wide">
                    {feature.text}
                  </span>
                </div>)}
            </div>
          </div>

          {}
          <div ref={imageRef} className={`lg:w-[40%] relative w-full max-w-lg mx-auto lg:max-w-none mt-12 lg:mt-0 transition-all duration-1000 delay-300 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            {}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[80%] bg-primary/20 blur-[120px] rounded-full mix-blend-screen pointer-events-none"></div>
            
            {}
            <div className="relative z-10 transform-gpu hover:-translate-y-2 transition-transform duration-700 ease-out">
              <img src="https://harmless-hippo.10web.cloud/wp-content/uploads/2026/04/LDS-Services.jpeg" alt="Precision delivery truck and regional semi-truck fleet" className="w-full h-auto object-contain drop-shadow-[0_20px_50px_rgba(0,0,0,0.7)]" loading="eager" />
            </div>
          </div>

        </div>
      </div>
    </section>;
}